import React from 'react'
import PropTypes from 'prop-types'

const Credits = ({ children }) => {
  return (
    <div
      style={{
        fontSize: 14,
        ontFamily: 'Roboto Slab',
        '& p': {
          margin: '5px 0'
        }
      }}
    >
      {children}
    </div>
  )
}

Credits.propTypes = {
  children: PropTypes.node
}

export default Credits
